import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';
import { FieldWidthEnum } from '@data/cer-data-types';

export class FinanceLedgerAccountForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {
    viewSet.viewAdd(this.viewGet());
  }

  private viewGet(): CerFormView {
    const filterNum = this.routeOptions.navigation?.columnNameChild == 'num';    

    const view = new CerFormView();

    view.viewMetadata = {
      dataApiName: 'FinanceLedgerAccount',
      primaryKey: 'id', titleFields: ['num','name'], baseFields: ['id'],
      allowCreate: false, allowEdit: false, allowDelete: false,
//      navigations: [{ link: 'nav', foreignKey: {entity: 'voucher', column: 'voucherNum', parentColumn: 'voucher'}}]
    };

    view.fieldMetadata = [
      { name: 'num', text: 'Konto' },
      { name: 'name', text: 'Navn', widthType: FieldWidthEnum.XXL },
      { name: 'taxCode', text: 'Momskode', foreignKeyType: 'financeTaxCode' },
      { name: 'projCostType', text: 'Art', foreignKeyType: 'financeProjectCostType', widthType: FieldWidthEnum.XL },
    ];

    return view;
  }
}
